export enum CampaignStatusEnum {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  ACTIVE = 'ACTIVE',
  ENDED = 'ENDED',
  REJECTED = 'REJECTED',
}

export const campaignStatusLabel: Record<CampaignStatusEnum, string> = {
  [CampaignStatusEnum.DRAFT]: 'แบบร่าง',
  [CampaignStatusEnum.PENDING]: 'รออนุมัติ',
  [CampaignStatusEnum.APPROVED]: 'อนุมัติแล้ว',
  [CampaignStatusEnum.ACTIVE]: 'กำลังดำเนินการ',
  [CampaignStatusEnum.ENDED]: 'สิ้นสุด',
  [CampaignStatusEnum.REJECTED]: 'ปฏิเสธ',
}
